module.exports = __webpack_public_path__ + "static/media/shadow.5cf404ba.png";